
const KeyUri = {
//BACKEND_URI : "http://localhost:5000/api"

    // Development URL
   
//BACKEND_URI: "https://coral-app-pfm2c.ondigitalocean.app/api"
//BACKEND_URI:"https://squid-app-9qp4x.ondigitalocean.app/api"

    // Production URL
  
BACKEND_URI:"https://production-goldfish-app-7oxlf.ondigitalocean.app/api"
    
  //rzp_test_IwdUdqA2kXyNYm 

}

const storedToken = localStorage.getItem('tokenUser') ? localStorage.getItem('tokenUser') : null;
//const storedUserToken = localStorage.getItem('tokenuser') ? localStorage.getItem('tokenuser') : null;

const token = storedToken ? storedToken.slice(1, -1) : null;
//const usertoken = storedUserToken ? storedUserToken.slice(1, -1) : null;

const config = {
    
    headers: {
    Accept: "application/json",
    // Authorization: token ? `Bearer ${token}`: undefined ||usertoken?`Bearer ${usertoken}`: undefined ,
    Authorization: (token ? `Bearer ${token}` : (token ? `Bearer ${token}` : undefined))    

}


};

export { KeyUri, config };

window.KeyUri = KeyUri;
window.config = config;

